import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import { CheckIcon } from '../../../components/Icon';
import Text from '../../../components/Text';
import { TV_DASHBOARD_COLOR_ENUM } from '../../../comm/constant';

const useStyles = makeStyles(() => ({
  CheckIcon: {
    fontSize: '1rem',
    color: '#FFFFFF',
  },
}));

const Card = ({ type, name, color, checked, onClick, status, model }) => {
  const classes = useStyles();
  const colorDetail = _.find(TV_DASHBOARD_COLOR_ENUM, (item) => item.title === (color ?? 'Default'));
  return (
    <Box
      display="flex"
      alignItems="center"
      gridGap="0.63rem"
      p="0.5rem 1rem"
      borderRadius="0.5rem"
      border={`1.5px solid ${colorDetail?.borderColor}`}
      bgcolor={colorDetail?.bgColor}
      height="2.5rem"
      style={{ cursor: onClick ? 'pointer' : 'default' }}
      onClick={onClick}
      title={`${status}\n${model}`}
    >
      {type === 'category' &&
        (checked ? (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="1.5rem"
            height="1.5rem"
            borderRadius="0.25rem"
            bgcolor="#28D2AB"
          >
            <CheckIcon className={classes.CheckIcon} />
          </Box>
        ) : (
          <Box border="1px solid #E4E7EB" bgcolor="#FFF" borderRadius="0.3125rem" width="1.5rem" height="1.5rem" />
        ))}
      <Text
        color={type === 'category' ? '#000000' : '#2E4469'}
        fontSize="1.125rem"
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: type === 'category' ? 'unset' : '10rem',
        }}
      >
        {name}
      </Text>
    </Box>
  );
};

export default Card;
